import { http } from '@/lib/api/http';
import type { ApiSuccess } from '@/shared/types/contracts';

export type RPSRoomPlayerInfo = {
  employee_id: string;
  display_name: string | null;
  avatar_url: string | null;
};

export type RPSRoomStatus = 'waiting' | 'playing' | 'ended';

export type RPSRoomSummary = {
  room_id: string;
  name: string;
  owner: RPSRoomPlayerInfo | null;
  status: RPSRoomStatus;
  max_games: number;
  time_limit_sec: number;
  player1: RPSRoomPlayerInfo | null;
  player2: RPSRoomPlayerInfo | null;
  has_opponent: boolean;
  created_at: number;
};

export type CreateRpsRoomPayload = {
  name: string;
  password: string;
  max_games: number;
  time_limit_sec: number;
};

export async function listRpsRooms(): Promise<RPSRoomSummary[]> {
  const { data } = await http.get<ApiSuccess<RPSRoomSummary[]>>('/api/rps-rooms');
  return data.data;
}

export async function getRpsRoom(id: string): Promise<RPSRoomSummary> {
  const { data } = await http.get<ApiSuccess<RPSRoomSummary>>(`/api/rps-rooms/${id}`);
  return data.data;
}

export async function createRpsRoom(payload: CreateRpsRoomPayload): Promise<RPSRoomSummary> {
  const { data } = await http.post<ApiSuccess<RPSRoomSummary>>('/api/rps-rooms', payload);
  return data.data;
}
